<script>
// Todo: Flag for removal
import _ from 'lodash'

export default {
  props: {
    allItems: {
      type: Array,
      default() {
        return []
      }
    },

    selectedItem: {
      type: Object
    },

    title: {
      type: String,
      default: 'Choose Item'
    },

    searchAttributes: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      item: this.selectedItem || null,
      editActive: false,
      query: ''
    }
  },

  methods: {
    containsQuery(item) {
      if (!this.query.trim()) {
        return true
      } else {
        let containsQuery = false
        for (let attr of this.searchAttributes) {
          let query = this.query.trim().toLowerCase()
          containsQuery =
            _.get(item, attr) &&
            _.get(item, attr).length &&
            _.get(item, attr)
              .toLowerCase()
              .indexOf(query) > -1
          if (containsQuery) {
            break
          }
        }
        return containsQuery
      }
    },
    select(item) {
      this.item = item
      this.editActive = false
      this.$emit('change', item)
    }
  }
}
</script>
<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense>
          <v-toolbar-title class="body-2 beez-bold "
            >{{ title }}
          </v-toolbar-title>
          <v-spacer />
          <transition name="fade" mode="out-in">
            <v-btn
              flat
              icon
              v-if="!editActive"
              key="edit"
              @click="editActive = true"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </transition>
        </v-toolbar>
        <transition name="fade" mode="out-in">
          <v-list two-line v-if="!editActive" key="view-list">
            <v-list-tile avatar v-if="!item">
              <v-list-tile-avatar>
                <v-icon class="ma-3">face</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <slot name="empty-list-placeholder-selected">
                    No selected item.
                    <a style="color:#60b0db" @click="editActive = true"
                      >Pick an item</a
                    ></slot
                  >
                </v-list-tile-title>
                <v-list-tile-sub-title></v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple @click="editActive = true">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile avatar v-else>
              <slot name="list-item" :item="item"></slot>
            </v-list-tile>
          </v-list>

          <v-list two-line v-else key="edit-list">
            <v-container fuild>
              <v-layout row>
                <v-flex shrink>
                  <v-tooltip bottom>
                    <v-icon
                      class="mt-4"
                      slot="activator"
                      medium
                      @click="editActive = false"
                      >navigate_before
                    </v-icon>
                    <span>Back</span>
                  </v-tooltip>
                </v-flex>
                <v-flex grow>
                  <v-list-tile>
                    <v-list-tile-avatar>
                      <v-icon>search</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-sub-title>
                        <v-text-field
                          color="secondary"
                          label="Search Item"
                          v-model="query"
                          xs5
                        >
                        </v-text-field>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-tooltip bottom>
                      <v-btn slot="activator" flat icon @click="query = ''">
                        <v-icon>clear</v-icon>
                      </v-btn>
                      <span>Clear search</span>
                    </v-tooltip>
                  </v-list-tile>
                </v-flex>
              </v-layout>
              <v-list-tile
                avatar
                v-for="(item, i) in allItems"
                :key="i"
                v-show="containsQuery(item)"
                @click="select(item)"
              >
                <slot name="list-item" :item="item"></slot>
              </v-list-tile>
            </v-container>
          </v-list>
        </transition>
      </v-card>
    </v-flex>
  </v-layout>
</template>
